module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedBoldItalic.8c3bc60.woff2";